import React, { memo, useEffect, useState } from 'react'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/Info'
import CloseIcon from '@material-ui/icons/Close'
import green from '@material-ui/core/colors/green'
import amber from '@material-ui/core/colors/amber'
import IconButton from '@material-ui/core/IconButton'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import WarningIcon from '@material-ui/icons/Warning'
import { makeStyles } from '@material-ui/core/styles'
import LOG from '../logging/Logger'
import { isMobileOnly } from 'react-device-detect'

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
}

const autoHide = {
  success: 6000,
  warning: null,
  error: null,
  info: 6000
}

const useStyles = makeStyles(theme => ({
  snackbar: {
    height: 'auto',
    lineHeight: '28px',
    padding: 24,
    whiteSpace: 'pre-line'
  },
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.main
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing()
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  },
  margin: {
    margin: theme.spacing()
  },
  selectable: {
    cursor: 'pointer'
  }
}))

export default memo(
  ({
    message,
    open,
    onClick,
    onCancel = () => {},
    onClose = () => {},
    variant,
    keepOpen,
    autoHideDurationOverride,
    preventCancel = false,
    transitionComponent = undefined,
    position
  }) => {
    LOG.debug('Render: Popup')

    const classes = useStyles()

    const [visible, setVisible] = useState(false)

    const Icon =
      variantIcon[variant === undefined || variant === '' ? 'error' : variant]
    const autoHideDuration =
      autoHideDurationOverride !== undefined
        ? autoHideDurationOverride
        : autoHide[
            variant === undefined || variant === '' || keepOpen
              ? 'error'
              : variant
          ]

    useEffect(() => {
      setVisible(open)
    }, [open])

    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return
      }

      onClose()
      setVisible(false)
    }

    const handleCancel = () => {
      onCancel()
      setVisible(false)
    }

    return (
      <Snackbar
        className={classes.snackbar}
        anchorOrigin={{
          vertical: position ? position : isMobileOnly ? 'top' : 'bottom',
          horizontal: 'center'
        }}
        open={visible}
        autoHideDuration={onClick !== undefined ? null : autoHideDuration}
        onClose={handleClose}
        TransitionComponent={transitionComponent}
      >
        <SnackbarContent
          className={classes[variant]}
          aria-describedby='client-snackbar'
          message={
            <div
              id='client-snackbar'
              className={`${classes.message} ${
                onClick ? classes.selectable : undefined
              }`}
              onClick={onClick}
            >
              <Icon className={`${classes.icon} ${classes.iconVariant}`} />
              {message}
            </div>
          }
          action={
            preventCancel
              ? undefined
              : [
                  <IconButton
                    key='close'
                    aria-label='Close'
                    color='inherit'
                    className={classes.close}
                    onClick={handleCancel}
                  >
                    <CloseIcon className={classes.icon} />
                  </IconButton>
                ]
          }
        />
      </Snackbar>
    )
  }
)
